import { Controller } from "@hotwired/stimulus";
import "./component.scss";

// A collapsed section must not swallow a browser validation message: open it
// as soon as a field inside reports invalid (the event does not bubble, hence
// the capture phase).
export default class extends Controller {
  connect() {
    this.element.addEventListener("invalid", this.reveal, true);
  }

  disconnect() {
    this.element.removeEventListener("invalid", this.reveal, true);
  }

  reveal = () => {
    this.element.open = true;
  };
}
